var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * One eligible (priceable) billable unit, with the provisional resolved gross
 * for foldout subtotal display. The assembler re-resolves at persist time, so
 * this snapshot is display-only and may drift between read and create.
 */
export class OpenBillingUnitDto {
    id;
    treatmentPlanId;
    billableServiceItemId;
    sequenceInPlan;
    deliveredAt;
    priceGross;
    currency;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingUnitDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingUnitDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingUnitDto.prototype, "billableServiceItemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OpenBillingUnitDto.prototype, "sequenceInPlan", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OpenBillingUnitDto.prototype, "deliveredAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OpenBillingUnitDto.prototype, "priceGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingUnitDto.prototype, "currency", void 0);
/** One unbilled unit grouped by plan within a cluster. */
export class OpenBillingPlanGroupDto {
    treatmentPlanId;
    units;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingPlanGroupDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    Type(() => OpenBillingUnitDto),
    __metadata("design:type", Array)
], OpenBillingPlanGroupDto.prototype, "units", void 0);
/**
 * One cluster (the grouper's hard-partition: `payerDomainCode × currency ×
 * officeLocationId`, with `patientId` implicit at patient scope). Carries
 * the deterministic `clusterKey` the create command echoes back in
 * `consolidatedClusterKeys` (Slice 3) and the `canConsolidate` flag the
 * modal uses to show / hide the "Auf einer Rechnung zusammenfassen"
 * toggle (only meaningful when the cluster spans ≥ 2 plans).
 */
export class OpenBillingClusterDto {
    clusterKey;
    payerDomainCode;
    currency;
    officeLocationId;
    canConsolidate;
    planGroups;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingClusterDto.prototype, "clusterKey", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingClusterDto.prototype, "payerDomainCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingClusterDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OpenBillingClusterDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], OpenBillingClusterDto.prototype, "canConsolidate", void 0);
__decorate([
    Expose(),
    Type(() => OpenBillingPlanGroupDto),
    __metadata("design:type", Array)
], OpenBillingClusterDto.prototype, "planGroups", void 0);
/**
 * One unit the resolver could not price, with the single distinct reason
 * (`AgreementPinMissingError` / `PriceListNotFoundError` /
 * `NoPriceListItemError`) translated to a German UI string. Skip-with-reason
 * is *only* this unpriceable class — non-DELIVERED, already-billed, and
 * GKV/BG/Beihilfe units are omitted silently.
 */
export class SkippedBillingUnitDto {
    id;
    treatmentPlanId;
    billableServiceItemId;
    sequenceInPlan;
    deliveredAt;
    reason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], SkippedBillingUnitDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SkippedBillingUnitDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SkippedBillingUnitDto.prototype, "billableServiceItemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], SkippedBillingUnitDto.prototype, "sequenceInPlan", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], SkippedBillingUnitDto.prototype, "deliveredAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SkippedBillingUnitDto.prototype, "reason", void 0);
/**
 * Patient-wide "Offene Leistungen" read model — clusters of priceable
 * units (one per hard-partition the grouper would form), plus skipped rows.
 * Live read-model: nothing is persisted; the frontend refetches on each load.
 */
export class PatientOpenBillingDto {
    patientId;
    clusters;
    skipped;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientOpenBillingDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    Type(() => OpenBillingClusterDto),
    __metadata("design:type", Array)
], PatientOpenBillingDto.prototype, "clusters", void 0);
__decorate([
    Expose(),
    Type(() => SkippedBillingUnitDto),
    __metadata("design:type", Array)
], PatientOpenBillingDto.prototype, "skipped", void 0);
//# sourceMappingURL=patient-open-billing.response.dto.js.map